<template>
	<div :class="['red-packet-card', msgInfo.selfSend ? 'mine' : '']" @click="onClick">
		<div class="card">
			<!-- 左侧红包图标 -->
			<div class="envelope-wrapper">
				<div class="envelope-icon">
					<div class="envelope-body"></div>
					<div class="envelope-flap"></div>
					<div class="coin">
						<span class="coin-symbol">¥</span>
					</div>
				</div>
			</div>

			<!-- 右侧文字内容 -->
			<div class="content">
				<div class="main-text">{{ remarkText }}</div>
				<div class="status-text">{{ statusText }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "RedPacketCard",
	props: {
		msgInfo: {
			type: Object,
			required: true
		},
		mineName: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			redPacketInfo: null,
			loading: true
		}
	},
	computed: {
		remarkText() {
			// 从 content 中解析红包信息
			// 如果有红包详情，显示祝福语；否则显示默认文字
			if (this.redPacketInfo && this.redPacketInfo.message) {
				return this.redPacketInfo.message;
			}
			return '恭喜发财，大吉大利';
		},
		statusText() {
			if (this.msgInfo.selfSend) {
				return '查看红包';
			}
			if (this.redPacketInfo && this.redPacketInfo.received) {
				return '已领取';
			}
			return '领取红包';
		}
	},
	methods: {
		onClick() {
			if (this.loading) {
				console.log('红包加载中...');
				return;
			}

			if (!this.redPacketInfo) {
				return;
			}

			// 判断是否已领取或自己发的
			if (this.redPacketInfo.received) {
				// 已领取，显示领取记录
				this.$emit('click', {
					...this.redPacketInfo,
					showRecords: true
				});
				return;
			}

			if (this.redPacketInfo.senderId === this.userStore.userInfo.id) {
				// 自己发的红包，显示领取记录
				this.$emit('click', {
					...this.redPacketInfo,
					showRecords: true
				});
				return;
			}

			// 未领取，打开领取弹窗
			this.$emit('click', this.redPacketInfo);
		},
		async loadRedPacketDetail() {
			try {
				this.loading = true;
				const packetNo = this.msgInfo.content;

				// 调用红包详情API
				const res = await this.$http({
					url: `/redpacket/detail/${packetNo}`,
					method: 'GET'
				});

				this.redPacketInfo = res.data || res;
			} catch (error) {
				console.error('获取红包详情失败:', error);
				// 降级方案
				this.redPacketInfo = {
					packetNo: this.msgInfo.content,
					message: '恭喜发财',
					received: false
				};
			} finally {
				this.loading = false;
			}
		}
	},
	mounted() {
		// 挂载时加载红包详情
		this.loadRedPacketDetail();
	}
}
</script>

<style lang="scss" scoped>
.red-packet-card {
	display: inline-block;
	min-width: 260px;
	max-width: 320px;
	background: linear-gradient(135deg, #FFA73D 0%, #FFB84D 100%);
	color: white;
	border-radius: 8px;
	padding: 16px 20px;
	box-shadow: 0 2px 8px rgba(255, 167, 61, 0.3);
	cursor: pointer;
	transition: all 0.2s ease;
	user-select: none;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(255, 167, 61, 0.4);
	}

	&:active {
		transform: translateY(0);
	}

	&.mine {
		background: linear-gradient(135deg, #FFB84D 0%, #FFC964 100%);
	}

	.card {
		display: flex;
		align-items: center;
		gap: 16px;
	}

	/* 红包图标 */
	.envelope-wrapper {
		position: relative;
		flex-shrink: 0;
	}

	.envelope-icon {
		position: relative;
		width: 60px;
		height: 50px;
	}

	.envelope-body {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 60px;
		height: 40px;
		background: linear-gradient(135deg, #E63946 0%, #F25C66 50%, #E63946 100%);
		border-radius: 4px;
		box-shadow: 0 2px 6px rgba(230, 57, 70, 0.3);
	}

	.envelope-flap {
		position: absolute;
		top: 0;
		left: 0;
		width: 0;
		height: 0;
		border-left: 30px solid transparent;
		border-right: 30px solid transparent;
		border-top: 25px solid #C62D39;
		filter: drop-shadow(0 1px 3px rgba(198, 45, 57, 0.2));
	}

	.coin {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 28px;
		height: 28px;
		background: linear-gradient(135deg, #FFD56F 0%, #FFBF3F 100%);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 2px 6px rgba(255, 191, 63, 0.4),
			inset 0 1px 2px rgba(255, 255, 255, 0.5);
		z-index: 2;
	}

	.coin-symbol {
		font-size: 16px;
		font-weight: 700;
		color: #E63946;
		text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
	}

	/* 文字内容 */
	.content {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.main-text {
		font-size: 15px;
		font-weight: 600;
		color: #fff;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.status-text {
		font-size: 13px;
		color: rgba(255, 255, 255, 0.85);
	}
}
</style>

